export const instituicao = "FDV"
export const publicURL = "https://triagem-fdv.web.app";